export const PACKAGE_NAME = 'jiraServicedeskEmailRequestIntegrationSectionMessage';
export const TEAM_NAME = 'itops-mithril';
export const addEmailAccountArticleId = '5HYkUFADaPTFLqkD2wdA8h';
export const readMoreArticleId = '5HYkUFADaPTFLqkD2wdA8h';
